import { Link } from 'react-router-dom';

import { ROUTE_PM, ROUTE_KNM } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

import styles from './KnmListRenderErpId.module.scss';

interface IKnmListErpId {
  id: string | number;
}

export function KnmListErpIdCell<T extends IKnmListErpId>({ value, row, isPm, isTest }: ITableRenderCell<T>) {
  return (
    <div className={styles.ErpIdCellWrapper}>
      <Link
        className="shared-table-link"
        to={isPm ? ROUTE_PM(row.id) : ROUTE_KNM(row.id)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </Link>
      {isTest && <span className={styles.TestUserWrapper}>ТЕСТ</span>}
    </div>
  );
}
